import React from 'react';
import { connect } from 'react-redux';
// Level popup imports
import LevelPopupLayout from '../layout';
import LevelGoals from '../levelGoals';

class LevelPopupAlmost extends React.Component {
    render = () => {
        const { levelPopup } = this.props;

        return (
            <LevelPopupLayout id="level-almost-popup" imgSrc="icons/ster_bril.png" imgAlt="Ster met bril" isSmallImg title="BIJNA GEHAALD" clickable>
                <div className="level-description">
                    <span className="desc">
                        Probeer het opnieuw:
                        <br />
                        {levelPopup.description}
                    </span>
                </div>
                <LevelGoals />
            </LevelPopupLayout>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelPopup: state.levelPopup
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelPopupAlmost);
